import { Auth } from 'Shared/auth';

onDomReady(() => {
   if (!Auth.isLoggedIn() && $('errorName').get('text') == 'e403' && !App.disableAutoLogin) {
      Auth.required({
         message: '',
         locked: false,
         ignoreSSO: App.onManage,
         stayInWindow: true,
         register: true,
         onAuthorize: () => {
            window.location.reload();
         },
      });
   }
});
